import { Link } from 'react-router-dom';
import { BrandWordmark } from './BrandWordmark';

type Props = {
  size?: number;
  className?: string;
};

export const BrandHomeLink = ({ size, className }: Props) => (
  <Link className={className} to="/" aria-label="CanaBiz, página inicial">
    <BrandWordmark size={size} />
  </Link>
);
